import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { RefreshSharedService } from '../../../refresh-shared-service';

@Component({
  selector: 'data-protection-vc',
  styles: [require('./dataprotection-vc.scss')],
  template: require('./dataprotection-vc.html')
})
export default class DataProtectionVC {
  private isDpsHealthy: boolean = false;
  private loaded: boolean = false;
  private hasRoles: boolean = false;
  constructor(private translate: TranslateService,
              private router: Router, private route: ActivatedRoute, public authService: AuthService,
              private rss: RefreshSharedService) {
      translate.use(GlobalVariables.LOCALE);
      this.authService.getDpsHealthChangeEvent().subscribe(data => {
        this.isDpsHealthy = ( data && data.isHealthy ) ? true : false;
        this.loaded = true;
      });
  }

  ngOnInit() {
      this.loaded = ( this.authService ) ? true : false;
      this.isDpsHealthy = ( this.loaded && this.authService.DPS_HEALTH && this.authService.DPS_HEALTH.isHealthy ) ? true : false;
      let roles = this.authService.loggedInUserInfo.roles;
      roles.forEach((role) => {
          if (role === 'System Administrator' || role === 'Enterprise Administrator') {
              this.hasRoles = true;
          }
      });
  }

  onTabSelected(selectedTabLink) {
    if (selectedTabLink.id === 'manage-dps-vc-link') {
       // Keeping the commented code for future reference
       // this.router.navigateByUrl('services/dataprotection/(dps:manage//dps-details:resourcepool)');
    }
    switch (selectedTabLink.id) {
      case 'manage-dps-vc-link':
        this.rss.setParam({
            'loadedComponent': 'DPSManageVC',
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        break;
      case 'dashboard-dps-vc-link':
        this.rss.setParam({
            'loadedComponent': 'DPSDashboardVC',
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        break;
      case 'deleted-vc-dps-vc-link':
        this.rss.setParam({
            'loadedComponent': 'DPSDeletedVmVc',
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        break;
      default:
    }
  }

  onTabIndexChanged(index) {
  }

  onTabContentActivated(tabContent) {
  }

  ngOnDestroy() {
    this.rss.resetParam();
  }
};



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-vc.component.ts